<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormUserSelect
      v-bind="$props"
      :value="normalizedValue"
      @input="update"
    />
  </div>
</template>

<script>
import FormMixin from './FormMixin'
import FormUserSelect from './FormUserSelect'

export default {
  mixins: [ FormMixin ],
  components: { FormUserSelect },
  computed: {
    normalizedValue () {
      const owners = (this.value || []).map(el => el.ownerId)
      return [ ...new Set(owners) ]
    },
  },
  methods: {
    update (value) {
      value = value || []
      this.$emit('input', value.map(el => ({
        ownerType: 'user',
        ownerId: el,
      })))
    },
  },
}

</script>
